import { useState } from 'react'
import styles from './AiBuilderTab.module.css'
import AiSkillsTab from '../aiSkillsTab/AiSkillsTab'
import AiBuilderSettingsTab from './AiBuilderSettingsTab'
import AiUsageTab from '../aiUsageTab/AiUsageTab'

type SubTab = 'skills' | 'settings' | 'usage'

export default function AiBuilderTab() {
  const [activeSubTab, setActiveSubTab] = useState<SubTab>('settings')

  return (
    <div className={styles.wrapper}>
      <div className={styles.subTabs}>
        <button
          className={`${styles.subTab} ${activeSubTab === 'settings' ? styles.subTabActive : ''}`}
          onClick={() => setActiveSubTab('settings')}
        >
          Settings
        </button>
        <button
          className={`${styles.subTab} ${activeSubTab === 'skills' ? styles.subTabActive : ''}`}
          onClick={() => setActiveSubTab('skills')}
        >
          Skills
        </button>
        <button
          className={`${styles.subTab} ${activeSubTab === 'usage' ? styles.subTabActive : ''}`}
          onClick={() => setActiveSubTab('usage')}
        >
          Usage
        </button>

      </div>

      {activeSubTab === 'skills' && <AiSkillsTab />}
      {activeSubTab === 'settings' && <AiBuilderSettingsTab />}
      {activeSubTab === 'usage' && <AiUsageTab />}
    </div>
  )
}
